import { Ability } from "ember-can";

export default class ComorbidityAndAllergyAbility extends Ability {
  get canEdit(): boolean {
    return true;
  }
}
